import http from '../../plugins/axios';

export default {

    getBalance(data) {
        return http.get({
            url: '/admin/temporary/current',
            data,
        })
    },

    getSnapBalance(data) {
        return http.get({
            url: '/admin/temporary/snapshoot',
            data
        })
    },

    getBill(data) {
        return http.get({
            url: '/admin/temporary/bill',
            data,
        })
    },

    reSetBalance(data) {
        return http.post({
            url: '/admin/temporary/setBalance',
            data,
            dataType: 'form'
        })
    },

    getUnFinishOrder(data) {
        return http.get({
            url : '/admin/temporary/unFinishOrder',
            data
        })
    },

    cancelOrder(data) {
        return http.post({
            url : '/admin/temporary/cancelOrder',
            data,
            dataType: 'form'
        })
    },

    pledgeUnLock(data) {
        return http.post({
            url : '/admin/temporary/pledge/unLock',
            data,
            dataType: 'form'
        })
    }

}